/**
 * Modify Sentry's Browser SDK.
 *
 * @link https://github.com/stayallive/wp-sentry#client-side-hook
 * @link https://docs.sentry.io/platforms/javascript/configuration/options/
 *
 * @returns bool whether to init Sentry Browser or not
 */
function wp_sentry_hook(options) {
  options.beforeSend = (event) => {
    // decrease the severity to the specified messages
    if (event.exception.values[0].value) {
      const decreaseSeverityTo = [
        'Unexpected token .',
        'Unexpected token ?',
        "Unexpected token '.'",
      ];
      for (const message of decreaseSeverityTo) {
        if (event.exception.values[0].value.includes(message)) {
          event.level = 'info';
        }
      }
    }
    return event;
  };
  return true;
}
